import { useTranslation } from 'react-i18next'

import CodeText from '../CodeText/CodeText'
import * as Styles from './styles'

const MatchedContent = ({ proposedCode, isHs }) => {
  const { t } = useTranslation()

  const matchKey = isHs ? 'HS code coincide con la sugerencia!' : 'HTS code coincide con la sugerencia!'

  return (
    <Styles.RightColumnMatch>
      <CodeText code={proposedCode} variant="match" />
      <Styles.MatchText>{t(matchKey)}</Styles.MatchText>
    </Styles.RightColumnMatch>
  )
}

export default MatchedContent
